// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1nsnj","signatureButtonsRight":"ModalSign_signatureButtonsRight__24opd"};